document.addEventListener("DOMContentLoaded", function () {
    function setupDropdown(dropdownId, selectedId, optionsId, hiddenInputId) {
        const dropdown = document.getElementById(dropdownId);
        const selected = document.getElementById(selectedId);
        const options = document.getElementById(optionsId);
        const hiddenInput = document.getElementById(hiddenInputId);

        selected.addEventListener("click", function (e) {
            e.stopPropagation(); // Prevent bubbling
            dropdown.classList.toggle("active");
        });

        options.querySelectorAll("li").forEach(function (item) {
            item.addEventListener("click", function () {
                const value = item.getAttribute("data-value");
                selected.textContent = value;
                hiddenInput.value = value;
                dropdown.classList.remove("active");
            });
        });

        // Close dropdown when clicking outside
        document.addEventListener("click", function (e) {
            if (!dropdown.contains(e.target)) {
                dropdown.classList.remove("active");
            }
        });
    }

   setupDropdown("dropdown-type", "selected-type", "options-type", "capital-type");
setupDropdown("dropdown-material", "selected-material", "options-material", "capital-material");
setupDropdown("dropdown-interest", "selected-interest", "options-interest", "capital-interest");

});
